// AGC: Admin button primitive — themed variants for the admin panel
import React from 'react'

type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost' | 'icon'

interface AdminButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  children: React.ReactNode
}

const VARIANT_CLASSES: Record<ButtonVariant, string> = {
  primary:
    'bg-brand-primary text-white hover:bg-brand-dark dark:bg-brand-light dark:text-[#052e22] dark:hover:opacity-90',
  secondary:
    'bg-transparent border border-slate-200 text-slate-700 hover:bg-slate-50 dark:border-white/10 dark:text-slate-300 dark:hover:bg-white/5',
  danger:
    'bg-error-600 text-white hover:bg-error-700 dark:bg-error-500 dark:hover:bg-error-600',
  ghost:
    'bg-transparent text-brand-primary hover:bg-brand-primary/5 dark:text-brand-light dark:hover:bg-brand-light/10',
  icon:
    'bg-white border border-slate-200 text-brand-primary hover:bg-slate-50 dark:bg-admin-card-dark dark:border-white/5 dark:text-brand-light dark:hover:bg-white/5',
}

export const AdminButton: React.FC<AdminButtonProps> = ({
  variant = 'primary',
  className = '',
  children,
  ...props
}) => (
  <button
    className={`
      inline-flex items-center justify-center gap-2 rounded-lg px-3.5 py-2
      text-sm font-medium transition-colors focus-visible:outline-none
      focus-visible:ring-2 focus-visible:ring-brand-primary dark:focus-visible:ring-brand-light
      disabled:opacity-50 disabled:pointer-events-none
      ${VARIANT_CLASSES[variant]} ${className}
    `.replace(/\s+/g, ' ').trim()}
    {...props}
  >
    {children}
  </button>
)
